export const getPaymentMethodColor = (method: string) => {
  switch (method.toLowerCase()) {
    case "cash":
      return "success";
    case "card":
      return "info";
    case "mobile":
      return "warning";
    default:
      return "default";
  }
};

export const getPaymentMethodIcon = (method: string) => {
  switch (method.toLowerCase()) {
    case "cash":
      return "payments";
    case "card":
      return "credit_card";
    case "mobile":
      return "phone_android";
    default:
      return "help";
  }
};
